import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Engleski from '../views/Engleski.vue'
import PdfView from '../views/PdfView.vue'

const routes = [
  {
    path: '/hr',
    name: 'hrvatski',
    component: HomeView
  },
  {
    path: '/',
    name: 'home',
    component: Engleski
  },
  {
    path: '/pdf',
    name: 'pdf',
    component: PdfView
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

})


export default router
